export const bigStatement = `supertitle: Of the 773 million adults worldwide who cannot read, two-thirds are women — a disparity that has persisted for three decades.
  align: center
subtitle: UNESCO Institute for Statistics, Global Education Monitoring Report, 2023.
  align: center
`;
